import { DataProviderMethod, UrlArray } from './types';

export function defaultUrlRenderer(
  url: string | UrlArray,
  method?: DataProviderMethod
) {
  return Array.isArray(url) ? url.join('/') : url;
}
